import React from 'react';
import Metadata from './perimeters.metadata';
import StyleSettingsFormSection from '../styleSettingsFormSection.jsx';

import { Container, Col } from '../forms.styles';

class Content extends StyleSettingsFormSection {
  static isSectionMatched(props, filterBy) {
    return (
      StyleSettingsFormSection.isFieldGroupMatched(
        props,
        Metadata.perimeters,
        filterBy
      ) ||
      StyleSettingsFormSection.isFieldGroupMatched(
        props,
        Metadata.seams,
        filterBy
      )
    );
  }

  render() {
    return (
      <Container>
        <Col>{this.renderFieldGroup(Metadata.perimeters)}</Col>
        <Col>{this.renderFieldGroup(Metadata.seams)}</Col>
      </Container>
    );
  }
}

export default Content;
